cv.AccountView = Marionette.LayoutView.extend({
  template: cv.Templates['account/view'],

  events : {
  },

  regions : {
  },

  validation: {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.title = 'My Account';

    console.log('AccountView initialized.');
  },

  onAttach: function(){
  }
});